import { Drawer, DrawerContent, DrawerOverlay, IconButton } from "@chakra-ui/react";
import { ReactNode } from "react";

interface SidebarDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  placement: "left" | "right";
  children: ReactNode;
  triggerButton: ReactNode;
  showTrigger: boolean;
  width?: string;
  triggerButtonProps?: {
    position?: any;
    top?: string;
    left?: string;
    right?: string;
    zIndex?: number;
    [key: string]: any;
  };
}

export default function SidebarDrawer({
  isOpen,
  onClose,
  placement,
  children,
  triggerButton,
  showTrigger,
  width,
  triggerButtonProps = {},
}: SidebarDrawerProps) {
  return (
    <>
      {showTrigger && triggerButton}

      <Drawer isOpen={isOpen} placement={placement} onClose={onClose}>
        <DrawerOverlay height="100%!important" />
        <DrawerContent {...(width && { maxW: width, w: width })}>{children}</DrawerContent>
      </Drawer>
    </>
  );
}
